module.exports = __webpack_public_path__ + "img/Takagi.8d74aa2c.png";